import { useSearchParams } from 'react-router';

export const FeatureParams = {
    DOCUMENTS: 'documents',
    CSV_IMPORT: 'csv_import',
};

export const useFeatureParams = () => {
    const [searchParams] = useSearchParams();
    const documents = searchParams.get(FeatureParams.DOCUMENTS) === 'true';
    const csvImport = searchParams.get(FeatureParams.CSV_IMPORT) === 'true';

    return {
        deleteDocuments: documents,
        csvImportEnabled: csvImport,
    };
};
